<template>
  <div id="offers_section">
    <div class="content" style="padding: 110px 0 0 0">
      <div class="top-nav" v-if="fetched && !error" :class="[lang === 'ar' ? 'arabicTabs' : '']">
        <div style="width: 100vw" class="tabsContainer">
          <v-tabs v-model="tab" grow centered show-arrows class="nav-tab">
            <v-tabs-slider color="#FFCB05"></v-tabs-slider>
            <v-tab v-if="this.$store.state.selectedNumber !== null" :class="[lang === 'ar' ? 'arabicTabs' : '']">
              <span :class="[lang === 'ar' ? 'regular-ar' : 'regular-en']">{{ $t('offers.special') }}</span>
            </v-tab>
            <v-tab v-for="(item, i) in offers.items" :key="i" :class="[lang === 'ar' ? 'arabicTabs' : '']">
              <span :class="[lang === 'ar' ? 'regular-ar' : 'regular-en']">{{ item.text }}</span>
            </v-tab>
          </v-tabs>
        </div>
      </div>
      <div :class="[this.$lang === 'ar' ? 'flex-row-reverse' : '', 'bottom-nav filter-blur-50 border-bottom-white-1-50']"
        v-if="fetched && !error && this.$store.state.selectedNumber === null">
        <div :class="[this.$lang === 'ar' ? 'flex-row-reverse' : '', 'nameContainer']">
          <div class="homeIcon" @click="$router.push('/')">
            <img src="../../assets/icons/homeIcon.svg" height="20px" width="20px">
          </div>
          <div :class="[this.$lang === 'ar' ? 'rotation' : '', 'arrowIcon']">
            <img src="../../assets/icons/rightArrow.svg" height="15px" width="15px">
          </div>
          <div class="titleName">{{ $t('offers.title') }}</div>
        </div>
        <div :class="[this.$lang === 'ar' ? 'flex-start-center' : '', 'checkContainer']">
          <form :class="[this.$lang === 'ar' ? 'flex-row-reverse' : '', 'filterForm']">
            <div class="checkName" :class="this.$lang === 'ar' ? 'dir-rtl' : ''">{{ $t('popularBundles.showResults') }}
            </div>
            <div class="check">
              <input type="radio" id="pre" name="filter" v-model="lineType" value="0" @click="arabicRadio" checked>
              <label for="pre" class="radioLabel pre">{{ $t('popularBundles.PrePaid') }}</label>
            </div>
            <div class="check">
              <input type="radio" id="post" name="filter" v-model="lineType" value="1" @click="arabicRadio">
              <label for="post" class="radioLabel post">{{ $t('popularBundles.PostPaid') }}</label>
            </div>
          </form>
        </div>
      </div>
      <div
        :class="[!fetched ? 'd-flex align-items-center justify-center' : this.$store.state.selectedNumber === null ? 'padding-100' : 'padding-50', 'inner-content']">
        <div v-if="!fetched || error" class="handle-response-container d-flex align-center justify-center">
          <Error v-if="error" />
          <Loader v-if="!fetched && !error" />
        </div>
        <div v-if="fetched && !error">
          <v-tabs-items :key="key" v-model="tab" :touchless="true">
            <v-tab-item v-if="this.$store.state.selectedNumber !== null">
              <div style="background: rgb(242,242,242)">
                <slider-section id="offers" sliderHolder="offer" :lineType="lineType" :obj="specialOffers"
                  method="getOffersByGsm" :data="special.items[0].data" class="back-en" />
              </div>
            </v-tab-item>
            <v-tab-item v-for="(item, i) in offers.items" :key="i">
              <div style="background: rgb(242,242,242)" v-if="offers.items.length > 0">
                <slider-section id="offers" :lineType="Number(lineType)" sliderHolder="offer" :obj="offersByCategoryRepo"
                  method="getByCategory" :data="item.data" class="back-ar" />
              </div>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SliderSection from '../../components/sections/SliderSection'
import $ from 'jquery'
import OffersCategoriesRepository from '../../repositories/OffersCategoriesRepository'
import OffersByCategoryRepository from '../../repositories/OffersByCategoryRepository'
import Error from '../../components/errorHandle/Error'
import Loader from '../../components/LoaderBtn/Loader'
import SpecialOffersRepository from '../../repositories/SpecialOffersRepository'
export default {
  name: 'Offers',
  components: { SliderSection, Loader, Error },
  data () {
    return {
      lang: this.$lang,
      activeId: null,
      offersCategoriesRepo: new OffersCategoriesRepository(),
      offersByCategoryRepo: new OffersByCategoryRepository(),
      specialOffers: new SpecialOffersRepository(),
      comp: 'SliderSection',
      tab: {},
      offers: {
        title: 'Offers',
        items: []
      },
      special: {
        title: 'Special Offers',
        items: []
      },
      lineType: 0,
      fetched: false,
      error: false,
      size: 5,
      key: 0
    }
  },
  created () {
    // console.log(this.$route.path)
    // this.getOffers()
    this.special.items[0] = {
      id: -1,
      text: '',
      data: {
        // id: -1,
        sliderType: 'offer',
        // lineType: this.lineType,
        main: {
          sectionId: -1,
          cardType: 'offers',
          title: this.$t('offers.special'),
          description: this.$t('offersDesc'),
          image: ''
        },
        slider: []
      }
    }
    this.$watch(() => {
      return this.$store.state.searchValue
    }, (val) => {
      this.$forceUpdate()
      this.key++
    })
    this.getOffers()
  },
  destroyed () {
    this.$store.state.showSearch = false
    this.$store.state.searchValue = ''
  },
  mounted () {
    this.$store.state.showSearch = true
    this.arabic()
    this.$watch(() => {
      return this.$store.state.selectedNumber
    }, (val) => {
      this.$forceUpdate()
      this.key++
    })
  },
  watch: {
    tab (val) {
      this.$store.state.searchValue = ''
      // Hide search input in special offers tab only
      this.$store.state.showSearch = !(val === 0 && this.$store.state.selectedNumber !== null)
      this.$store.state.offerType = val === 0 && this.$store.state.selectedNumber !== null ? 'special' : 'general'
    },
    lineType (val) {
      this.handleLineType(val)
    }
  },
  methods: {
    handleLineType (val) {
      for (let i = 0; i < this.offers.items.length; i++) {
        this.offers.items[i].data.lineType = val
      }
      // this.tab = -1
      // this.tabsId = []
      // this.offers.items = []
      // this.fetched = false
      // this.error = false
      this.$store.state.searchValue = ''
      this.$forceUpdate()
      this.key++
      // this.getOffers(true)
    },
    async getOffers () {
      try {
        const response = await this.offersCategoriesRepo.get()
        if (response.status === 200) {
          this.offers.items = []
          for (let i = 0; i < response.data.length; i++) {
            this.offers.items.push({
              id: response.data[i].id,
              text: response.data[i].title,
              data: {
                id: response.data[i].id,
                sliderType: 'offer',
                lineType: this.lineType,
                main: {
                  sectionId: 'offers',
                  cardType: 'offers',
                  title: response.data[i].title,
                  description: this.$t('offersDesc'),
                  image: ''
                },
                slider: []
              }
            })
          }
          this.fetched = true
        } else {
          this.fetched = false
          this.error = true
        }
      } catch (e) {
        this.fetched = false
        this.error = true
      } finally {
        // if (status) {
        //   this.$forceUpdate()
        //   this.key++
        // }
      }
    },
    arabicRadio () {
      if (this.$lang === 'ar') {
        $('.post').css('font-family', 'Mtn-arabic-regular')
        $('.pre').css('font-family', 'Mtn-arabic-regular')
        $('.post').css('font-size', '10px')
        $('.pre').css('font-size', '10px')
        if ($('#pre').is(':checked')) {
          $('.pre').css('font-family', 'Mtn-arabic-bold')
          $('.pre').css('font-size', '10px')
          // $('.post').css('font-family', 'Mtn-arabic-regular')
          // $('.post').css('font-size', '11px')
        } else if ($('#post').is(':checked')) {
          $('.post').css('font-family', 'Mtn-arabic-bold')
          $('.post').css('font-size', '10px')
          // $('.pre').css('font-family', 'Mtn-arabic-regular')
          // $('.pre').css('font-size', '11px')
        }
      }
    },
    arabic () {
      if (this.lang === 'ar') {
        $('.top-nav').css('direction', 'rtl')
        $('.bottom-nav').css('direction', 'rtl')
        $('.checkName').css('font-family', 'Mtn-arabic-bold')
        $('.checkName').css('direction', 'rtl')
        $('.arrowIcon').css('transform', 'rotateY(180deg)')
        $('.tabsContainer').addClass('arabicTabContainer')
        $('.nav-tab .v-tab').css('transform', 'rotateY(180deg)')
        // $('.radioLabel').css('font-size', '10px')
        $('.radioLabel').css('font-family', 'Mtn-regular')
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "src/assets/sass/main";
@import "src/assets/sass/modules/tabs";
@import "src/assets/sass/modules/extraNav";

.dir-rtl {
  direction: rtl !important;
}

.back-en {
  background: url("../../assets/images/circles-back-en.png") no-repeat;
}

.back-ar {
  background: url("../../assets/images/circles-back-ar.png") rgba(242, 242, 242, 0.5) no-repeat right;
}

#offers_section {
  background: rgb(242, 242, 242)
}

.rotation {
  transform: rotate(180deg);
}

.inner-content {
  min-height: calc(100vh - 395px);
}

.padding-100 {
  padding-top: 100px;
}

.padding-50 {
  padding-top: 50px;
}

.bundles-min {
  min-height: calc(100vh - 495px);
}

.handle-response-container {
  min-height: calc(100vh - (220px + 285.6px));
}

.gray-gradient-bottom0 {
  background-image: linear-gradient(to bottom, #F2F2F2, #e1e1e1);
  -moz-background-image: -moz-linear-gradient(to bottom, #F2F2F2, rgba(242, 242, 242, 1));
  -o-background-image: -o-linear-gradient(to bottom, #F2F2F2, rgba(242, 242, 242, 1));
  -webkit-background-image: -webkit-linear-gradient(to bottom, #F2F2F2, rgba(242, 242, 242, 1));
}
</style>
<style lang="scss">
#offers_section {
  .theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active) {
    color: rgba(29, 29, 29, 0.6) !important;
  }

  .v-tabs {
    height: 100%;
    border-bottom: 2px solid #ffffff;
  }

  .v-tab {
    font-size: 13px !important;
    /*border-bottom: 2px solid #ffffff;*/
    text-transform: capitalize;
  }

  .v-tab.v-tab--active {
    color: #FFCB05;
    font-style: italic;
    font-weight: bold;
  }

  .v-window.v-item-group.theme--light.v-tabs-items {
    background: transparent;
  }

  .bottom-nav {
    border-top: none !important;
  }

  .v-tabs.nav-tab.v-tabs--centered.v-tabs--grow.theme--light {
    position: relative;
  }

  .v-item-group.theme--light.v-slide-group.v-tabs-bar.v-tabs-bar--is-mobile.v-tabs-bar--show-arrows.primary--text,
  .v-item-group.theme--light.v-slide-group.v-tabs-bar.v-tabs-bar--show-arrows.primary--text {
    position: absolute;
    top: 2px;
  }
}</style>
